var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeObfuscated = function SvgEyeObfuscated(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 17.5a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5Zm0 1.25a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.875a8.375 8.375 0 0 0-8.375 8.375h-1.25a9.625 9.625 0 0 1 19.25 0h-1.25A8.375 8.375 0 0 0 12 5.875Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.04 20.779c2.137-5.654 6.463-17.127 6.741-17.974l1.188.39c-.29.881-4.633 12.4-6.76 18.026l-1.169-.442Z",
    fill: "currentColor"
  })));
};
export default SvgEyeObfuscated;